import React from "react";
import ConfimationModel from "./ConfirmationModel";
import Popup from "./../../ppi/ppi-detail/utils/popup";
class AccountYearFormComponent extends React.Component {
  render() {
    var induceds = [],
      induced,
      totalInduceds = 0;
    if (this.props.induceds) {
      this.props.induceds.map((i) => {
        if (
          (induced = induceds.find(
            (i) => i.project == induced && induced.project.name
          ))
        ) {
          induced.total += i.gain - i.loss;
        } else {
          induceds.push({
            project: i.project.name,
            total: i.gain - i.loss,
          });
        }
        totalInduceds += i.gain - i.loss;
      });
    }
    return (
      <div>
        <form className="account-year-editor-form">
          {this.props.value.yearAccount ? (
            <div className="actual-account-year">
              <div className="actual-account-year-row">Valeur actuelle</div>
              <div className="actual-account-year-row">
                <span className="row-title">Type de valeur</span>
                <span className="row-value">
                  {this.props.value.yearAccount.percentile
                    ? "pourcentage"
                    : "valeur"}
                </span>
              </div>
              <div className="actual-account-year-row">
                <span className="row-title">Valeur actuelle</span>
                <span className="row-value">
                  {this.props.value.yearAccount.amount}
                </span>
              </div>
            </div>
          ) : null}
          {this.props.step == 1 ? (
            <div className="form-content">
              <div className="columns is-desktop">
                <div className="column">
                  <p className="field is-horizontal">
                    <span className="field-label is-normal">
                      <label className="label">Type de Valeur</label>
                    </span>
                    <span className="field-body">
                      <span className="field">
                        <span className="control scenario-radios">
                          <label htmlFor="account-year-percentile">
                            <input
                              type="radio"
                              id="account-year-percentile"
                              name={
                                "account-" + this.props.account.id + "-type"
                              }
                              value="percentile"
                              onChange={() =>
                                this.props.handleCheck("percentile")
                              }
                            />
                            Pourcentage
                          </label>
                          <label htmlFor="account-year-value">
                            <input
                              type="radio"
                              id="account-year-value"
                              name={
                                "account-" + this.props.account.id + "-type"
                              }
                              value="simple"
                              defaultChecked={true}
                              onChange={() => this.props.handleCheck("simple")}
                            />
                            Valeur
                          </label>
                        </span>
                      </span>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="form-content">
              {this.props.percentile ? (
                <div className="scenario-account-year-induceds">
                  <span className="induceds-title">
                    {this.props.type == "revenues" ? "Recettes" : "Charges"}{" "}
                    induites du PPI :{" "}
                  </span>
                  {this.props.induceds.length == 0 ? (
                    <span className="no-induceds">
                      Aucune{" "}
                      {this.props.type == "revenues" ? "recette" : "charge"}{" "}
                      induite dans le PPI pour ce compte
                    </span>
                  ) : (
                    <div className="induceds-list">
                      {induceds.map((induced) => (
                        <div className="induced-detail">
                          <span className="induced-project">
                            {induced.project}
                          </span>
                          <span className="induced-amount">
                            {induced.total}
                          </span>{" "}
                          €
                        </div>
                      ))}
                      <div className="induced-detail total-induceds">
                        <span className="induced-project">
                          <strong>
                            Total des{" "}
                            {this.props.type == "revenues"
                              ? "recettes"
                              : "charges"}
                          </strong>
                        </span>
                        <span className="induced-amount">{totalInduceds}€</span>
                      </div>
                    </div>
                  )}
                </div>
              ) : null}
              <div className="columns is-desktop">
                <div className="column">
                  <p className="field is-horizontal">
                    <span className="field-label is-normal">
                      <label className="label" htmlFor="amount">
                        {this.props.percentile ? "Pourcentage" : "Valeur"}
                      </label>
                    </span>
                    <span className="field-body">
                      <span className="field">
                        <span className="control">
                          <input
                            key={"amount-" + this.props.account.id}
                            ref={(input) => {
                              this.amountInput = input;
                            }}
                            type="text"
                            name="amount"
                            defaultValue={this.props.amount}
                            onChange={(value) => this.props.onChange(value)}
                            required
                          />
                        </span>
                      </span>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          )}
          {this.props.step == 1 ? (
            <button
              className={`button is-primary ${
                this.props.submitting ? "is-loading" : ""
              }`}
              onClick={(e) => this.props.onSubmit(e)}
            >
              Suivant
            </button>
          ) : (
            <button
              className={`button is-primary ${
                this.props.submitting ? "is-loading" : ""
              }`}
              onClick={(e) => this.props.onSubmit(e)}
            >
              Enregistrer
            </button>
          )}
          {this.props.step == 2 ? (
            <button
              className={`button is-secondary ${
                this.props.submitting ? "is-loading" : ""
              }`}
              onClick={this.props.onPrevious}
            >
              Précédent
            </button>
          ) : this.props.value.yearAccount ? (
            <button
              className={`button is-secondary ${
                this.props.submitting ? "is-loading" : ""
              }`}
              onClick={(e) => this.props.onDelete(e)}
            >
              Supprimer la valeur
            </button>
          ) : null}
        </form>
        {this.props.confirm && (
          <Popup
            onHide={() => this.props.handleHideModel()}
            title={this.props.title}
          >
            <ConfimationModel
              submitting={this.props.submitting}
              onChange={this.props.handleCheckType}
              confirm={this.props.checked}
              handleConfirm={this.props.handleConfirm}
            />
          </Popup>
        )}
      </div>
    );
  }

  _handleFocus(e) {
    e.preventDefault();
    setTimeout(() => {
      this.amountInput.focus();
    }, 100);
  }
}

export default AccountYearFormComponent;



// WEBPACK FOOTER //
// ./src/component/scenarii/common/account-year-form-component.js